'use strict';

module.exports = function () {
    $('body').on('click', '.contact-shop', function () {
        window.location = $(this).data('href');
    });
};
